import React, { useRef } from 'react';
import lang from '../utils/languageConstants';
import { useDispatch, useSelector } from 'react-redux';
import openai from '../utils/openai';
import { API_OPTIONS } from '../utils/constant';
import { addGptMovieResult } from '../utils/gptSlice';

const GptSearchBar = () => {
  const dispatch = useDispatch();
  const lang_key = useSelector(store => store.config.lang);
  const searchText = useRef(null);

  //search movie in TMDB
  const searchMovieTMDB = async (movie) => {
    const data = await fetch('https://api.themoviedb.org/3/search/movie?query=' + movie + '&include_adult=false&language=en-US&page=1', API_OPTIONS);
    const json = await data.json();
    return json.results;
  };

  const handleGptSearchClick = async () => {
    // console.log(searchText.current.value);
    //make an API call to GPT API and get Movie Results

    const gptQuery = "Act as a Movie Recommendation system and suggest some movies for the query :" + searchText.current.value + ". only give me names of 5 movies, comma seperated like the example result given ahead. Example Result: Titanic, Nemo, Home Alone, Spiderman, Don."

    const gptResults = await openai.chat.completions.create({
      messages: [{ role: 'user', content: gptQuery }],
      model: 'gpt-4o-mini',
    });

    if (!gptResults.choices) {
      //Todo: Error Handling
    }

    // console.log(gptResults.choices?.[0]?.message?.content);
    const gptMovies = gptResults.choices?.[0]?.message?.content.split(","); //gives array of movies

    //For each movie search TMDB API
    const data = gptMovies.map((movie) => searchMovieTMDB(movie));

    const tmdbResults = await Promise.all(data);
    console.log(tmdbResults);
    dispatch(addGptMovieResult({ movieNames: gptMovies, movieResults: tmdbResults }));

  };


  return (
    <div className='pt-[35%] md:pt-[10%] flex justify-center'>
      <form className='w-full md:w-1/2 bg-black grid grid-cols-12' onSubmit={(e) => e.preventDefault()}>
        <input ref={searchText} type='text' className='p-4 m-4 col-span-9' placeholder={lang[lang_key].gptSearchPlaceholder} />
        <button className='col-span-3 m-3 py-2 px-4 bg-red-700 text-white rounded-lg' onClick={handleGptSearchClick}>
          {lang[lang_key].search}
        </button>
      </form>
    </div>
  )
}

export default GptSearchBar